import { useOutletContext } from "react-router";

import { EnrichedHohishType } from "@/services/2/hohishes/types";

export const useEnrichedHohishOutletContext = () => {
  const { hohish } = useOutletContext<{ hohish: EnrichedHohishType }>();
  return hohish;
};
